import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Container from '@magalu/stereo-ui/molecules/List';
export var List = styled(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  > li > a:hover {\n    text-decoration: underline;\n  }\n"])));